// DEV / STAGING -- the Azure Static Web App at
// https://white-meadow-0e78e6f00.7.azurestaticapps.net
//
// Substituted in for environment.ts by the `development` configuration in angular.json.
// Build with: npm run build:dev   (i.e. `ng build --configuration development`)
//
// This target owns the dev Azure backend. Local `ng serve` must NOT use it -- that is
// what environment.ts is for.
export const environment = {
  production: false,
  apiUrl: 'https://guludev-g8hbc0ffckfqg9by.eastasia-01.azurewebsites.net/api',
  appVersion: '1.0.0',
  appName: 'Gulu',
  avatar: {
    initialBg: '0068FF',
    initialFg: 'FFFFFF',
    size: 96,
  },
  messaging: {
    socketConnectBackoffMs: [1000, 2000, 4000, 8000, 16000, 30000] as const,
    typingStaleMs: 5000,
    newArrivalMs: 3000,
    pendingMatchWindowMs: 120_000,
  },
  cloudinary: {
    cloudName: '',
    uploadPreset: 'gulu-uploads',
  },
  socialProviders: {
    google: {
      enabled: true,
      clientId: '243352756401-nd7aqugiepst5g67aqlvbe73a29nel0j.apps.googleusercontent.com',
      redirectUri:
        'https://guludev-g8hbc0ffckfqg9by.eastasia-01.azurewebsites.net/api/auth/google/callback',
    },
    apple: {
      enabled: false,
      clientId: '',
      redirectUri: 'https://white-meadow-0e78e6f00.7.azurestaticapps.net/auth/callback/apple',
    },
    linkedin: {
      enabled: false,
      clientId: '',
      redirectUri: 'https://white-meadow-0e78e6f00.7.azurestaticapps.net/auth/callback/linkedin',
    },
  },
};
